import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { useGET_submissionsForPeerAssessmentQuery } from 'redux/api/peerAssessmentsApi'
import { FaFileDownload } from 'react-icons/fa'
import PeerAssessmentForm from 'components/organisms/forms/PeerAssessmentForm'
import Rubric from 'components/molecules/Rubric'

export interface IProps {
  assignment: any
  assignment_id: string
}

const slideProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  timeout: { enter: 225, exit: 195 }
};

const PeerAssessments: FC<IProps> = ({ assignment, assignment_id }) => {
  const { t } = useTranslation()


  const {data: submissions} = useGET_submissionsForPeerAssessmentQuery({id: assignment_id})


  return (

          <>
            <span dangerouslySetInnerHTML={{ __html:assignment.peer_assessment_instructions }} style={{ marginBottom: '20px' }} />
            
            { submissions && 
               submissions.results.map((s, index) => <Accordion 
                TransitionProps={slideProps}
                key={s.id} 
                defaultExpanded={submissions.results.length === 1 && index === 0}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    {s.graded_student?.title ?? `${t('common.submission')} ${index+1}`} 
                    {s.peer_assessment?.status === 'published' && ` / ${s.peer_assessment.grade_percentage}%`}
                </AccordionSummary>
                <AccordionDetails>  
                    <>
                      <div style={{ 
                        marginBottom: '30px', 
                        paddingBottom: '10px', 
                        borderBottom: '1px solid #ccc'
                      }}>

                        {s.description &&
                          <span dangerouslySetInnerHTML={{ __html: s.description }} />
                       }

                        {s.materials && s.materials.map(material => <div key={material.id} style={{ 
                          marginTop: '10px', 
                          paddingTop: '10px', 
                          borderTop: '1px solid #ccc'
                        }}>
                            <a href={material.url} target="_blank" rel="noreferrer"><FaFileDownload/> {material.title}</a>
                        </div>)}  

                      </div>

                      {assignment?.rubric?.id &&
                                <div style={{ marginBottom: '20px' }}><Rubric id={assignment?.rubric?.id} rubricGrades={[]} 
                                  selectHandler={(newSections: any[], percent: number) => {
                                    //setRubricSections(newSections)
                                }}/>
                        </div>
                     }


                      <PeerAssessmentForm submission={s}/>

                    </>   
                </AccordionDetails>
              </Accordion>  )
    
            }
          </> 
  )
}

export default PeerAssessments
